import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { Injectable, inject } from "@angular/core";
import { AutoBookProfile } from "@app/models/rest/auto-book-profile";
import { AutoBookProfileRestService } from "@app/services/hal/auto-book-profile-rest.service";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";

@Injectable({ providedIn: "root" })
export class AutoBookProfileStore extends RealTimeDataStore<AutoBookProfile> {
  constructor() {
    const autoBookProfileRestService = inject(AutoBookProfileRestService);
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(
      autoBookProfileRestService,
      webStompSubscriber,
      hateoasResourceService
    );
    super.subscribeToMessaging("AutoBookProfile");
  }
}
